import { EntityStatusState } from '@/store/root/root-store.model'
import { store } from '@/store/store'

export abstract class EntityState {
    protected abstract get entityName(): string
    abstract loadStates(): Promise<void>

    get states(): EntityStatusState[] {
        return store.getters.entitiesState[this.entityName] ?? []
    }
}
